module.exports = __webpack_public_path__ + "static/img/eleven-content-img.e5d0a582.png";